import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { TextField, ClassificatorField } from '../../atoms';
import { Row, Col, Spin } from 'antd';
import {
  FORM_REGISTER_BANK,
  formRegisterBankFields,
} from '../../constants/formRegister';
import { RegisterActions } from '../../components';
import { parseCharAndSpace, parseNumber } from '../../utils/formHelpers';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { updateLegalEntityActionCreator } from '../../actions/actionCreators/registerActionCreators';
import { getLegalEntity } from '../../schemas';
import {
  legalEntitySelector,
  getUpdateLegalEntity,
} from '../../reducers/registerReducer';
import {
  getRffFormValues,
  clearFormState,
} from '../../reducers/reactFinalFormReducer';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import FormStateToRedux from '../FormStateToRedux';
import validateSchema from './validateSchema';
import './RegisterBank.css';

export class RegisterBank extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    isLoading: PropTypes.bool,
    isAdmin: PropTypes.bool,
    isEditMode: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    updateLegalEntity: PropTypes.func.isRequired,
    clearFormState: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
    showRequestChangeModal: PropTypes.func,
  };

  onSubmit = async (values) => {
    const result = await this.props.updateLegalEntity(values);
    if (result?.error) {
      return { [FORM_ERROR]: 'submitFailed' };
    }
    this.props.clearFormState(FORM_REGISTER_BANK);
    this.props.onSubmitSuccess?.();
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      isAdmin,
      isEditMode,
      isLoading,
      showRequestChangeModal,
      initialValues,
    } = this.props;

    const inEditForNotAdmin = isEditMode && !isAdmin;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          validate={validate}
          initialValues={initialValues}
          initialValuesEqual={isEqual}
          keepDirtyOnReinitialize
          render={({ handleSubmit }) => (
            <form className="form-register-bank" onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_REGISTER_BANK} />
              <h2 className="form-register-bank__title">
                {inEditForNotAdmin ? t('bank.titleView') : t('bank.title')}
              </h2>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterBankFields.RECEIVER_NAME}
                    component={TextField}
                    type="text"
                    label={t('bank.receiverNameLabel')}
                    parse={parseCharAndSpace}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterBankFields.RECEIVER_REGISTRY_CODE}
                    component={TextField}
                    type="text"
                    parse={parseNumber}
                    label={t('bank.receiverRegistryCodeLabel')}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    name={formRegisterBankFields.REFERENCE_NUMBER}
                    component={TextField}
                    type="text"
                    parse={parseNumber}
                    label={t('bank.referenceNumberLabel')}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterBankFields.RECEIVER_KMKR}
                    component={TextField}
                    type="text"
                    label={t('bank.receiverKMKRLabel')}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col span={12}>
                  <Field
                    label={t('bank.bankNameLabel')}
                    name={formRegisterBankFields.BANK_NAME}
                    component={ClassificatorField}
                    classificatorType={ClassificatorField.types.bank}
                    disabled={inEditForNotAdmin}
                    withUndefinedOption
                  />
                </Col>
                <Col span={12}>
                  <Field
                    name={formRegisterBankFields.BANK_ACCOUNT}
                    component={TextField}
                    type="text"
                    label={t('bank.bankAccountLabel')}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <RegisterActions
                showRequestChangeModal={showRequestChangeModal}
                hasPrevious={hasPrevious}
                hasDone={hasDone}
                goPrevious={goPrevious}
                isEditMode={isEditMode}
                showSaveButton={isAdmin || !isEditMode}
                isAdmin={isAdmin}
                t={t}
              />
            </form>
          )}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => {
  const legalEntity = getLegalEntity(state, legalEntitySelector(state));
  const baseInitial = legalEntity?.toJS
    ? legalEntity.toJS()
    : legalEntity || {};
  const persisted = getRffFormValues(state, FORM_REGISTER_BANK).toJS();
  return {
    initialValues: { ...baseInitial, ...persisted },
    isLoading: getLoadingSelector(getUpdateLegalEntity)(state),
  };
};

const mapDispatchToProps = {
  updateLegalEntity: updateLegalEntityActionCreator,
  clearFormState,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterBank);
